import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import CheckInStyle from "../styles/pages/CheckIn.module.scss";
import arrowLeft from "../shared/images/icon-arrow-left.svg";
import { RootState } from "../store/GlobalStore";
import {
  useGetCheckInFormQuery,
  useUpdateCheckInMutation,
} from "../services/ReservationAPI";
import { setReservations } from "../store/slices/authSlice";
import { addNotification } from "../store/slices/notificationSlice";
import { useTranslation } from "react-i18next";
const CheckIn: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { asterioId } = useParams<{ asterioId: string }>();
  const { ressource } = useParams<{ ressource: string }>();
  const [alreadyCheckedIn, setAlreadyCheckedIn] = useState<boolean>(false);

  const [bookingResult, setBookingResult] = useState<any>(null);
  const authState = useSelector((state: RootState) => state.Auth);
  const { register, handleSubmit, watch, setValue } = useForm();

  const [updateCheckIn] = useUpdateCheckInMutation();
  const reservations = authState?.reservations;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const descriptionValue = watch("description", bookingResult?.Note || "");
  const { data: checkInData, refetch } = useGetCheckInFormQuery(
    ressource || ""
  );

  useEffect(() => {
    refetch(); // Rafraîchir les données lorsque la page est visitée
  }, [refetch]);

  useEffect(() => {
    const booking = findBooking(reservations, Number(asterioId), Number(id));
    setBookingResult(booking);
    console.log(bookingResult);
    console.log(asterioId);
    if (booking) {
      setAlreadyCheckedIn(true);
    }
  }, [reservations, asterioId, id]);

  const findBooking = (
    reservations: any,
    asterioId: number,
    bookingId: number
  ) => {
    const reservation = reservations?.find(
      (res: any) => res.asterioId === asterioId
    );
    if (!reservation) return null;
    const booking = reservation.Bookings?.find(
      (book: any) => book.bookingId === bookingId
    );
    return booking?.checkIn || null;
  };

  function transformData(data: any) {
    const result: { [key: string]: { name: string; value: boolean }[] } = {};

    for (const key in data) {
      // Ignorer les clés qui ne suivent pas le format attendu
      if (key === "description" || typeof data[key] !== "boolean") {
        continue;
      }
      //key = id Field
      //rechercher le filed et le title correspondant dans checkInData.Item
      const bookingField = checkInData?.Item.find(
        (item: any) => item.Field.some((field: any) => field.id === Number(key))
      );
      if(bookingField){
        const fieldTitle = bookingField.Title;
        const fieldName = bookingField.Field.find(
          (field: any) => field.id === Number(key)
        )?.name ?? "";
        const value = data[key];
        //if (data[key]) {
        // Ajouter le champ sous le bon titre
        if (!result[fieldTitle]) {
          result[fieldTitle] = [];
        }
        const temp: { name: string; value: boolean } = {
          name: fieldName,
          value: value,
        };
        result[fieldTitle].push(temp);
        //result[title].push([field]=data[key]);
        //}
      }
    }
    console.log("result", result);
    // Convertir l'objet en tableau
    return Object.entries(result).map(([title, fields]) => ({
      Title: title,
      Field: fields,
    }));
  }

  const onSubmit = async (formData: any) => {
    const data = {
      asterioId: Number(asterioId),
      bookingId: Number(id),
      Item: transformData(formData),
      Note: formData.description,
    };
    console.log("DATAAAA ===> " + JSON.stringify(data));
    try {
      const result = await updateCheckIn(data);
      console.log("Update successful:", result);
      if (result.data !== undefined) {
        dispatch(setReservations(result.data.reservations));
        dispatch(
          addNotification({
            message: "Le check-in a été effectué avec succès.",
            type: "success",
          })
        );
        navigate("/mon-compte");
      }
    } catch (error) {
      console.error("Failed to update:", error);
    }
  };

  return (
    <>
      <div className={CheckInStyle.TopContainer}>
        <Link to={`/booking/${id}`}>
          <button className={CheckInStyle.arrowButton}>
            <img src={arrowLeft} alt="Arrow Left" />
          </button>
        </Link>
        <h2>{t("entree")}</h2>
        <p>{t("entree_sub")}</p>
      </div>
      <form
        className={CheckInStyle.ModifyLesseeForm}
        onSubmit={handleSubmit(onSubmit)}
      >
        {alreadyCheckedIn &&
          Array.isArray(bookingResult?.Item) &&
          bookingResult.Item.map((item: any, itemIndex: number) => (
            <div key={itemIndex} className={CheckInStyle.Section}>
              <h3>{item.Title}</h3>
              {Array.isArray(item.Field) &&
                item.Field.map((field: any, fieldIndex: number) => {
                  const fieldName = `CheckedIn_${item.Title}_${field.name}`;
                  return (
                    <label
                      key={`${item.Title}_${field.name}`}
                      className={CheckInStyle.checkboxContainer}
                    >
                      <input
                        type="checkbox"
                        defaultChecked={field.value || false}
                        disabled={true}
                      />
                      <div className={CheckInStyle.customCheckbox}></div>
                      <div className={CheckInStyle.FieldName}>{field.name}</div>
                    </label>
                  );
                })}
            </div>
          ))}

        {!alreadyCheckedIn &&
          checkInData?.Item &&
          Array.isArray(checkInData.Item) &&
          checkInData.Item.map((item: any, itemIndex: number) => (
            <div key={itemIndex} className={CheckInStyle.Section}>
              <h3>{item.Title}</h3>
              {Array.isArray(item.Field) &&
                item.Field.map((field: any, fieldIndex: number) => {
                  const fieldName = `${field.id}`;
                  return (
                    <label
                      key={`${item.Title}_${field.name}`}
                      className={CheckInStyle.checkboxContainer}
                    >
                      <input
                        type="checkbox"
                        {...register(fieldName)}
                        defaultChecked={field.value || false}
                      />
                      <div className={CheckInStyle.customCheckbox}></div>
                      <div className={CheckInStyle.FieldName}>{field.name}</div>
                    </label>
                  );
                })}
            </div>
          ))}

        <div className={CheckInStyle.ModifyLesseeFormChild}>
          <div className={CheckInStyle.DesktopFormField}>
            <h3>{t("remarque")}</h3>
            <div className={CheckInStyle.TextAreaContainer}>
              <textarea
                id="description"
                {...register("description", { required: false })}
                defaultValue={bookingResult?.Note || ""}
                disabled={alreadyCheckedIn}
              />
              <label htmlFor="description">
                {descriptionValue || bookingResult?.Note ? "" : t("comment")}
              </label>
            </div>
          </div>
        </div>

        {!alreadyCheckedIn && (
          <div className={CheckInStyle.buttonContainer}>
            <Link to={`/booking/${id}`}>
              <button className={CheckInStyle.Cancel}>{t("annuler")}</button>
            </Link>
            <button type="submit" className={CheckInStyle.Update}>
              {t("send")}
            </button>
          </div>
        )}
      </form>
    </>
  );
};

export default CheckIn;
